import React from 'react'
import PropTypes from 'prop-types'
import { assetPrefix } from '../../stv.config'
import styles from './styles'
import buildQueryString from '../../utils/buildQueryString'
import PreviewPlayerControl from '../PreviewPlayerControl'

const playerQueryString = ({
  autoplayShortform,
  title,
  genre,
  subGenre,
}) => {
  const queryParams = {
    videoId: autoplayShortform?.videoId,
    drmEnabled: autoplayShortform?.drmEnabled,
    title,
    genre,
    subGenre,
    videoGuid: autoplayShortform?.guid,
    videoLength: autoplayShortform?.videoLength,
  }
  return buildQueryString(queryParams)
}

const PreviewPlayer = (props) => {
  const {
    playing, inViewScroll, userPaused, programmeHead,
  } = props
  const videoQueryString = playerQueryString(props)

  if (programmeHead) {
    setTimeout(() => {}, 6000)
  }

  return (
    <div className="PreviewPlayer">
      {/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
      <iframe
        className={`preview-iframe ${programmeHead ? 'programmeHead' : ''}`}
        data-testid="preview-iframe"
        name="stv-preview-iframe"
        scrolling="no"
        src={`${assetPrefix}/players/preview${videoQueryString}`}
        allowFullScreen
        allow="encrypted-media"
        muted
      />
      <div className={`controls ${programmeHead ? 'programmeHead' : ''}`}>
        <PreviewPlayerControl
          userPaused={userPaused}
          shouldDisplay={playing === true}
          controlType="play"
          disabled={!inViewScroll}
        />
        <PreviewPlayerControl
          userPaused={userPaused}
          shouldDisplay={playing === true}
          controlType="mute"
        />
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}

PreviewPlayer.propTypes = {
  playing: PropTypes.bool,
  autoplayShortform: PropTypes.shape({
    videoId: PropTypes.number,
    drmEnabled: PropTypes.bool,
    title: PropTypes.string,
    videoGuid: PropTypes.string,
    videoLength: PropTypes.number,
  }),
  inViewScroll: PropTypes.bool,
  userPaused: PropTypes.bool,
  programmeHead: PropTypes.bool,
}

PreviewPlayer.defaultProps = {
  playing: false,
  autoplayShortform: null,
  inViewScroll: true,
  userPaused: false,
  programmeHead: false,
}

export default PreviewPlayer
